module.exports = __webpack_public_path__ + "assets/img/img229.e1368ebf.png";